import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/blog",
  generate: "/blog/new/:blogId",
  generated: "/blog/:blogId",
  edit: "/blog/:blogId/edit"
};
